// src/components/CameraCapture.js
import React, { useRef, useState, useEffect } from 'react';
import { Box, Button, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';

function CameraCapture({ onCapture }) {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [stream, setStream] = useState(null);
  const [facingMode, setFacingMode] = useState('user'); // 'user' = frontal, 'environment' = trasera
  const [capturedImage, setCapturedImage] = useState(null);

  const startCamera = async () => {
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
    }

    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode },
        audio: false
      });
      videoRef.current.srcObject = mediaStream;
      setStream(mediaStream);
    } catch (err) {
      console.error('Error al acceder a la cámara:', err);
    }
  };

  const handleCapture = () => {
    const context = canvasRef.current.getContext('2d');
    context.drawImage(videoRef.current, 0, 0, 640, 480);
    canvasRef.current.toBlob(blob => {
      setCapturedImage(URL.createObjectURL(blob));
      onCapture(new File([blob], "foto.jpg", { type: blob.type }));
    }, 'image/jpeg');
  };

  const handleRetake = () => {
    setCapturedImage(null);
    onCapture(null);
    startCamera();
  };

  const handleCameraSwitch = (_, newMode) => {
    if (newMode !== null) {
      setFacingMode(newMode);
    }
  };

  useEffect(() => {
    startCamera();
    return () => {
      if (stream) {
        stream.getTracks().forEach(track => track.stop());
      }
    };
  }, [facingMode]);

  return (
    <Box sx={{ textAlign: 'center' }}>
      {capturedImage ? (
        <Box>
          <img src={capturedImage} alt="Captura" style={{ maxWidth: '100%' }} />
          <Box mt={2}>
            <Button variant="outlined" onClick={handleRetake}>
              Retomar Foto
            </Button>
          </Box>
        </Box>
      ) : (
        <>
          <video ref={videoRef} autoPlay playsInline width="100%" style={{ maxWidth: 640 }} />
          <canvas ref={canvasRef} width="640" height="480" style={{ display: 'none' }} />
          <Box mt={2}>
            <ToggleButtonGroup
              value={facingMode}
              exclusive
              onChange={handleCameraSwitch}
              aria-label="Cámara"
              size="small"
            >
              <ToggleButton value="user">Frontal</ToggleButton>
              <ToggleButton value="environment">Trasera</ToggleButton>
            </ToggleButtonGroup>
          </Box>
          <Box mt={2}>
            <Button variant="contained" onClick={handleCapture}>
              Tomar Foto
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
}

export default CameraCapture;
